module.exports = __webpack_public_path__ + "static/img/005.b9b68c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-yongdong/005.png
// module id = ZSxN
// module chunks = 1